import { DeviceRow } from 'components/tables/data/device/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the manufactured.
 */
export default function ManufacturedColumn({ data: { manufactured } }: { data: DeviceRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {manufactured}
    </P2Regular>
  );
}
